export enum MenuItemDisplayPricePrecalculation {
  Off = 'off',
  IncludeDefaultMods = 'include-default-mods',
  IncludeCheapestModsOnRequiredGroups = 'include-cheapest-mods-on-required-groups',
}
